"use strict";
/*
 * Created on 01.09.2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var PerformanceReportData_1 = require("../../report/promoperf/model/PerformanceReportData");
/**
 * Extension of promotion performance report row for purpose of export of report.
 * @author Radek Beran
 */


var PromotionPerformanceExportRowExtension =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionPerformanceExportRowExtension, _DomainObject_1$Domai);

  /**
   * @param promotion
   * @param promotionGosExtId external id of promotion group-of-sites
   * @param promotionTypeName name of promotion type
   * @param window
   * @param windowTypeName name of window type
   */
  function PromotionPerformanceExportRowExtension(promotion, promotionGosExtId, promotionTypeName, window, windowTypeName) {
    var _this;

    _classCallCheck(this, PromotionPerformanceExportRowExtension);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceExportRowExtension).call(this));
    _this.promotion = promotion;
    _this.promotionGosExtId = promotionGosExtId;
    _this.promotionTypeName = promotionTypeName;
    _this.window = window;
    _this.windowTypeName = windowTypeName;
    return _this;
  }

  _createClass(PromotionPerformanceExportRowExtension, null, [{
    key: "fromMat",
    value: function fromMat(mat) {
      return new PromotionPerformanceExportRowExtension(mat.promotion, mat.promotionGosExtId, mat.promotionTypeName, mat.window, mat.windowTypeName);
    }
  }]);

  return PromotionPerformanceExportRowExtension;
}(DomainObject_1.DomainObject);

exports.PromotionPerformanceExportRowExtension = PromotionPerformanceExportRowExtension;

PromotionPerformanceExportRowExtension.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionPerformanceExportRowExtension.name);
  return {
    promotion: builder.obj('promotion', PerformanceReportData_1.PerfPromotion.schema, function (mat) {
      return PerformanceReportData_1.PerfPromotion.fromMat(mat);
    }),
    promotionGosExtId: builder.opt(builder.str('promotionGosExtId')),
    promotionTypeName: builder.opt(builder.str('promotionTypeName')),
    window: builder.obj('window', PerformanceReportData_1.PerfWindow.schema, function (mat) {
      return PerformanceReportData_1.PerfWindow.fromMat(mat);
    }),
    windowTypeName: builder.opt(builder.str('windowTypeName'))
  };
}();